export default __webpack_public_path__ + "static/media/65.4310c23f.svg";